export const useFamilySwitchScreen = () => {
  const switchUpdatedAt = useNomadStorage('switchUpdatedAt', '', 'family');

  const profile = useProfileStore();

  const { isSwitchableProfile } = useFamilySwitchMember();

  const { completeAction, isCurrentAction } = useActionsStore();

  const isSwitchAvailable = computed(() => {
    if (!isSwitchableProfile.value) return false;
    if (!profile.isASubscriber) return false;
    if (profile.familyMembers.length <= 1) return false;
    const emptyToken = profile.familyMembers.some((member) => {
      const loginToken = member.loginToken || '';

      return loginToken == null;
    });

    return !emptyToken;
  });

  const needToShowScreen = computed(() => {
    if (!isSwitchAvailable.value) return false;
    if (
      switchUpdatedAt.value &&
      getTimeLeft(getNextDayDateIso(switchUpdatedAt.value)) > 0
    ) {
      return false;
    }
    return true;
  });

  const completeSwitch = () => {
    switchUpdatedAt.value = getToDayDateIso();
    if (isCurrentAction(ActionSelectUser))
      completeAction(ActionSelectUser, true);
  };

  return {
    isSwitchAvailable,
    needToShowScreen,
    completeSwitch,
  };
};
